import { __decorate, __metadata } from 'tslib';
import { ɵɵdefineInjectable, Injectable, Input, Component, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

let UiCToggleService = class UiCToggleService {
    constructor() { }
};
UiCToggleService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UiCToggleService_Factory() { return new UiCToggleService(); }, token: UiCToggleService, providedIn: "root" });
UiCToggleService = __decorate([
    Injectable({
        providedIn: 'root'
    }),
    __metadata("design:paramtypes", [])
], UiCToggleService);

let UiCToggleComponent = class UiCToggleComponent {
    constructor() { }
    ngOnInit() { }
};
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCToggleComponent.prototype, "color", void 0);
UiCToggleComponent = __decorate([
    Component({
        selector: 'ui-c-toggle',
        template: "<ion-item lines=\"none\">\n  <ion-toggle [color]=\"color\"></ion-toggle>\n  <ion-label><ng-content> </ng-content></ion-label>\n</ion-item>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCToggleComponent);

let UiCToggleModule = class UiCToggleModule {
};
UiCToggleModule = __decorate([
    NgModule({
        declarations: [UiCToggleComponent],
        imports: [IonicModule],
        exports: [UiCToggleComponent]
    })
], UiCToggleModule);

export { UiCToggleComponent, UiCToggleModule, UiCToggleService };
//# sourceMappingURL=wlp-ui-c-toggle.js.map
